import { createDmCoreClient, type DmCoreClient } from '@nsftx/seven-client-retail-dm-core'
import type { DMCoreSpaceOperatorLoginBodyData } from '#src/interfaces/DMCoreSpaceOperator'
import { dmCoreConfig } from '#src/plugins/dmCoreConfigPlugin'
import { useDmCoreSpaceOperatorStore } from '#src/stores/dmCoreSpaceOperatorStore'

let dmCore: DmCoreClient | undefined

const getClient = (): DmCoreClient => {
  if (!dmCore) {
    const tenantUuid = dmCoreConfig.getTenantUuid?.() ?? ''
    const deviceUuid = dmCoreConfig.getDeviceUuid?.() ?? ''

    dmCore = createDmCoreClient({
      baseUrl: import.meta.env.VITE_DM_CORE_API_BASE_URL,
      tenantUuid,
      deviceUuid,
      getAccessToken: () => useDmCoreSpaceOperatorStore().operatorLoginData?.access_token
    })
  }

  return dmCore
}

const getOperatorUuid = () => useDmCoreSpaceOperatorStore().operatorLoginData?.operator_uuid || ''

const loginOperator = (loginData: DMCoreSpaceOperatorLoginBodyData) =>
  getClient().spaceOperator.login({
    username: loginData.username,
    password: loginData.password
  })

const getOperatorData = () =>
  getClient().spaceOperator.getClientDetails({
    operatorUuid: getOperatorUuid()
  })

const refreshOperatorAccessToken = (refreshData: { refresh_token: string }) =>
  getClient().spaceOperator.refreshToken(refreshData)

const logoutOperator = () =>
  getClient().spaceOperator.logout({
    operatorUuid: getOperatorUuid()
  })

export default { loginOperator, getOperatorData, refreshOperatorAccessToken, logoutOperator }
